import { useTranslation } from 'react-i18next';

import { IPurchaseChartInfoData } from '@entities/purchase/model/index.types';

export const useGetPurchaseChartInfoFromQuery = ({ data }: { data: IPurchaseChartInfoData }) => {
    const { t } = useTranslation();
    if (!data) return {};

    return {
        basicCost: data.basicCost,
        basicRemainCost: data.basicRemainCost,
        budgetBalance: data.budgetBalance,
        currencySign: data.currency.sign,
        differenceBasicPositions: data.differenceData.hoverData.differenceBasicPositions,
        differenceExcessPositions: data.differenceData.hoverData.differenceExcessPositions,
        differenceSum: data.differenceData.sum,
        differenceType: data.differenceData.type,
        differenceDataPercent: data.differenceData.percent,
        enableReceiptsBtn: data.actions.receipts.view,
        enableSupplyRequestsBtn: data.actions.supplyRequests.view,
        enableOrdersRecognitionBtn: data.actions.ordersRecognition.view,
        overallMaterialCost: data.overallMaterialCost,
        receiptsCountUnreadMessages: data.actions.receipts.countUnreadMessages,
        supplyRequestsCountUnreadMessages: data.actions.supplyRequests.countUnreadMessages,
        orderRecognitionCountUnreadMessages: data.actions.ordersRecognition.countUnreadMessages,
        lastChartLabel:
            data.differenceData.type === 'saving'
                ? t('PurchaseChart.ChartBar.Label.economy')
                : data.differenceData.type === 'overspending'
                ? t('PurchaseChart.ChartBar.Label.overspending')
                : t('PurchaseChart.ChartBar.Label.unknown'),
    };
};
